import { MarkdownRender } from '@gov-nx/component/web';
import type {
	ConfirmationPromptProps,
	PopConfirmProps,
} from '@gov-nx/ui/types';
import { useBoolean } from '@gov-nx/utils/common';
import { Button } from '../Button/Button';
import { Dialog } from '../Dialog';

export const ConfirmationPrompt = ({
	children,
	isOpen,
	onCancel,
	onConfirm,
	strings,
	isDisabled,
	isLoading,
	icon,
}: ConfirmationPromptProps) => (
	<Dialog
		isOpen={isOpen}
		onClose={onCancel}
		title={<h3>{strings.title}</h3>}
		icon={icon}
		footer={
			<>
				<Button
					nativeType="button"
					aria-label={strings.buttons.cancel.wcagLabel}
					color="primary"
					type="base"
					size="m"
					isExpandedMobile
					isDisabled={isDisabled ?? false}
					onClick={onCancel}>
					{strings.buttons.cancel.label}
				</Button>
				<Button
					nativeType="button"
					aria-label={strings.buttons.confirm.wcagLabel}
					color="error"
					type="solid"
					size="m"
					isExpandedMobile
					isDisabled={isDisabled ?? false}
					isLoading={isLoading}
					onClick={onConfirm}>
					{strings.buttons.confirm.label}
				</Button>
			</>
		}>
		{children}
	</Dialog>
);

export const PopConfirm = ({
	onConfirm,
	strings,
	children,
	isDisabled,
	isLoading,
}: PopConfirmProps) => {
	const isOpen = useBoolean();

	return (
		<div>
			<ConfirmationPrompt
				isOpen={isOpen.value}
				isDisabled={isDisabled}
				isLoading={isLoading}
				onConfirm={() => onConfirm(isOpen.setFalse)}
				onCancel={isOpen.setFalse}
				strings={strings}>
				<MarkdownRender>{strings.body}</MarkdownRender>
			</ConfirmationPrompt>
			{children({ open: isOpen.setTrue })}
		</div>
	);
};
